export default __webpack_public_path__ + "static/instagram-92f52f6f569914795077f82adcf02870.png";